import React, { useState } from "react";

const DiplomacyEntryRequirements = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Direct Route",
      content: `To qualify for this programme through the Direct Entry Route, applicants must meet the following criteria:

- Academic Qualifications: Hold a recognised Bachelor’s degree or equivalent qualification
from an accredited institution.
- Leadership Experience: Demonstrate leadership experience in professional, academic, or
community settings, showcasing initiative & the ability to inspire positive change.
- Interest in Leadership: Show a strong passion for leadership with a commitment to fostering
innovation, adaptability, & meaningful impact in your chosen field.

- Programme Progression: Applicants following this route will be required to complete all modules in both the Postgraduate
Certificate in The Young Emerging Politician Course & the Postgraduate Diploma in Advanced
International Relations &amp; Diplomacy before advancing to the Master’s Stage.`,
    },
    {
      id: 2,
      title: "ESBD Route",
      content: `Applicants who have already completed the Postgraduate Certificate in The Young Emerging
Politician Course & the Postgraduate Diploma in Advanced International Relations &amp; Diplomacy
with ESBD can proceed directly to the Master’s Stage.

- Programme Progression: Students admitted through this route will only need to complete the Master’s Stage, which includes
advanced modules & the Dissertation.
`,
    },
    {
      id: 3,
      title: "Proof of Proficiency in the English Language",
      content: `The following qualifications meet our English language requirement:
      
- Native English speakers
- TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
- IELTS (Minimum score: 5.5)
- Cambridge ESOL (CAE, Minimum score: C1)
- English as the language of instruction in formal education
- Equivalent qualifications you wish to be considered.`,
    },
    {
      id: 4,
      title: "Identity Check",
      content: `Applicants must submit a valid ID during application & verify their identity via a live Zoom session
at the start of the course.`,
    },
  ];

  return (
    <div className="md:scroll-mt-44 scroll-mt-16 my-10" id="entry-requirements">
      <div className="bg-sddarkgray py-5">
        <div className="max-w-6xl mx-auto px-10 space-y-5">
          <h2 className="text-xl font-bold mb-4 text-gray-50">
            Entry Requirements
          </h2>
          <div className="bg-gray-50 h-1 w-14 "></div>
          <div className="space-y-1">
            {sections.map((section) => (
              <div key={section.id} className="border-y border-black">
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-2 px-3 bg-blue-50 hover:bg-blue-100 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium">{section.title}</span>
                    <span>{activeSection === section.id ? "▲" : "▼"}</span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-3 py-2 bg-sdbodywhite border-t border-gray-300">
                    <p className="text-gray-700 whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiplomacyEntryRequirements;
